import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "#1f1f1f",
  viewBox: "0 -960 960 960"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M120-320v-80h280v80zm0-160v-80h440v80zm0-160v-80h440v80zm520 480v-160H480v-80h160v-160h80v160h160v80H720v160z" }, null, -1)
  ]))]))
}
export default { render: render }